import React from 'react';
import { Link } from 'react-router-dom';
import Jumbotron from '../components/Jumbotron';

function ReturnPolicy() {
  return (
    <div>
      <Jumbotron>
        <h2>Our return/refund policy</h2>
        <p>
          TBD
        </p>
        <div>
          <ul>
            <li><Link to="/">Go back home</Link></li>
            <li><Link to="/orderHistory">See your order history</Link></li>
          </ul>
        </div>
      </Jumbotron>
    </div>
  );
}

export default ReturnPolicy;
